import { defaultTheme } from 'gd-design-library';

export const counter = {
  ...defaultTheme.counter,
  navButton: {
    ...defaultTheme.counter.navButton,
    default: {
      ...defaultTheme.counter.navButton.default,
      background: 'transparent',
    },
  },
};
